import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import phoneIcon from '@web/utils/src/assets/icons/functions/phone-icon.svg';
import webIcon from '@web/utils/src/assets/icons/functions/web-icon.svg';
import { Retailer } from '@/types';

interface RetailerContactProps {
  retailer: Retailer;
}
const RetailerContactInfo: React.FC<RetailerContactProps> = (props) => {
  const { retailer } = props;
  const { t } = useTranslation();

  return (
    <>
      <p className="font-bd text-2-2 mb-1-6">{t('retailer.contact')}</p>
      {retailer.phoneNumber && (
        <div className="flex gap-2-0 items-center my-1-0">
          <ReactSVG
            beforeInjection={(svg) => {
              svg.setAttribute('style', 'height: 2.4rem; width:auto');
            }}
            src={phoneIcon}
          />
          <span className="text-body1">{retailer.phoneNumber}</span>
        </div>
      )}
      {retailer.website && (
        <div className="flex gap-2-0 items-center my-1-0">
          <ReactSVG
            beforeInjection={(svg) => {
              svg.setAttribute('style', 'height: 2.4rem; width:auto');
            }}
            src={webIcon}
          />
          <a
            href={retailer.website}
            target="_blank"
            rel="noreferrer noopener"
            className="text-body1 underline"
          >
            {retailer.website}
          </a>
        </div>
      )}
    </>
  );
};

export default RetailerContactInfo;
